import "./kartklient.59311e3c.js";


      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirebbb8"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirebbb8"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
/*jshint esversion: 8 */ // import jwt_decode from 'jwt-decode';
// import backendService from './backendService';

parcelRequire("k43M4");

var $6ENs7 = parcelRequire("6ENs7");

var $9l1L2 = parcelRequire("9l1L2");
// Se dok for zlFetch her:  https://github.com/zellwk/zl-fetch
//import { swalAlert } from './commonService';
// const urlLogout = process.env.LOGOUT_URL;
//const urlLoginRefresh = process.env.LOGINREFRESH_URL;
const $c6fa1cc9bf76c207$var$urlLogin = "/sbaseApi/user/login";
window.basicLogin = $c6fa1cc9bf76c207$export$837be8f32497c8a5;
async function $c6fa1cc9bf76c207$export$837be8f32497c8a5() {
    document.body.style.cursor = 'progress';
    const email = document.getElementById("email");
    const password = document.getElementById("password");
    let response;
    if (email.checkValidity() && password.checkValidity()) {
        try {
            response = await (0, $9l1L2.default).post($c6fa1cc9bf76c207$var$urlLogin, {
                credentials: 'include',
                // headers: { "Access-Control-Allow-Origin": "http://localhost:1234/"},
                body: {
                    "name": email.value,
                    "password": password.value
                }
            });
        } catch (err) {
            document.body.style.cursor = 'auto';
            if (err.status === 401) $c6fa1cc9bf76c207$var$addLoginMessages('Logginn feilet, sjekk brukernavn og passord');
            $c6fa1cc9bf76c207$var$addLoginMessages('Logginn feilet');
            return;
        }
        const { token: token } = response.body;
        localStorage.setItem('token', token);
        localStorage.setItem('notFirsttime', true);
        document.body.style.cursor = 'auto';
        (0, $6ENs7.autoRedirect)();
    }
}
function $c6fa1cc9bf76c207$var$addLoginMessages(message) {
    if ($('#message').length > 0) $('#message').text(message);
}


//# sourceMappingURL=login.07255d8d.js.map
